// extracted by mini-css-extract-plugin
module.exports = {"timer":"EbookTimer_timer__3PyLj","timerInner":"EbookTimer_timerInner__2MrNE"};